import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";
import { CustomValidators } from 'src/app/model/custom-validators';

@Injectable({
  providedIn: 'root'
})
export class UserProductsFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(canchange: boolean, slug?: string, values?: any): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<string>({
        key: "transfert",
        label: 'Le transfert de compétences a été réalisé :',
        type: 'btn-radio',
        value: values?.transfert,
        options: [
          {key: 'libriciel', value: "Par un consultant Libriciel SCOP"},
          {key: 'interne', value: "En interne"},
        ],
        required: true,
        order: 1,
        payload: slug
      }),
    ];

    if (values) {
      if (values.transfert) {
        if (canchange) {
          questions.push(
            new FieldDefinition<string>({
              key: "replace",
              label: 'Le nouvel utilisateur remplace-t-il un ancien utilisateur dont il faut supprimer l\'accès au portail ?',
              type: 'btn-radio',
              required: true,
              value: values.replace,
              options: [
                {key: 'yes', value: "Oui"},
                {key: 'no', value: "Non"},
              ],
              order: 3,
              payload: slug
            })
          );
        }

        if (values.transfert === 'libriciel') {
          questions.push(
            new FieldDefinition<string>({
              key: "consultant",
              label: 'Nom et prénom du consultant',
              type: 'text',
              value: values.consultant,
              required: true,
              order: 2
            })
          );
        } else {
          questions.push(
            new FieldDefinition<string>({
              key: "formateur",
              label: 'Nom et prénom du formateur',
              type: 'text',
              value: values.formateur,
              required: true,
              order: 2
            })
          );
        }
      }
      if (values.replace === 'yes') {
        questions.push(
          new FieldDefinition<string>({
            key: "oldreferentname",
            label: 'Nom et prénom de l\'ancien utilisateur',
            type: 'text',
            value: values.oldreferentname,
            required: true,
            order: 4
          }),
          new FieldDefinition<string>({
            key: "oldreferentmail",
            label: 'Email de l\'ancien utilisateur',
            type: 'text',
            value: values.oldreferentmail,
            required: true,
            validators: [CustomValidators.email()],
            order: 5
          }))
      }
    }

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
